import lottie from "lottie-web";

export default function LottieWeb() {
  const lottieElements = document.querySelectorAll<HTMLElement>(".js-lottie-web, .js-lottie");

  if (!lottieElements.length) return;

  const observedAnimations = new Map<HTMLElement, any>();
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const animation = observedAnimations.get(entry.target as HTMLElement);

        if (!animation) return;

        if (entry.isIntersecting) {
          animation.play();
        } else {
          animation.pause();
        }
      });
    },
    {
      threshold: 0.25,
    },
  );

  lottieElements.forEach((el) => {
    const src = el.dataset.lottieSrc;

    if (!src) return;

    const shouldObserve = el.dataset.lottieObserve === "true";
    const wrapper = el.parentElement;
    const loader = wrapper?.querySelector<HTMLElement>(".lottie-loader");

    let hasRemovedLoader = false;
    const removeLoader = () => {
      if (hasRemovedLoader) return;

      hasRemovedLoader = true;
      loader?.remove();
    };

    const animation = lottie.loadAnimation({
      container: el,
      renderer: "svg",
      loop: true,
      autoplay: !shouldObserve,
      path: src,
    });

    animation.addEventListener("DOMLoaded", removeLoader);
    animation.addEventListener("data_ready", removeLoader);

    if (shouldObserve) {
      animation.pause();
      observedAnimations.set(el, animation);
      observer.observe(el);
    }
  });
}
